import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, TextField, Button } from '@mui/material';
import axios from 'axios';

export default function AdminSettingsPage() {
  const [settings, setSettings] = useState([]);
  const [cardFee, setCardFee] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get('https://api.safenetbanking.com/admin/settings', {
      headers: { Authorization: 'Bearer ' + token }
    }).then(res => {
      setSettings(res.data);
      const fee = res.data.find(s => s.key_name === 'card_fee');
      setCardFee(fee ? fee.value : '25');
      setLoading(false);
    });
  }, []);

  const handleSave = async () => {
    setSaving(true);
    const token = localStorage.getItem('token');
    try {
      await axios.patch('https://api.safenetbanking.com/admin/settings/card_fee', { value: cardFee }, {
        headers: { Authorization: 'Bearer ' + token }
      });
      setMsg('Card fee updated!');
    } catch {
      setMsg('Failed to update card fee.');
    }
    setSaving(false);
  };

  return (
    <Box maxWidth={400} mx="auto" mt={5}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" mb={2}>Admin Settings</Typography>
        <TextField
          label="Card Fee ($)"
          type="number"
          value={cardFee}
          onChange={e => setCardFee(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
        <Button variant="contained" onClick={handleSave} disabled={saving} fullWidth>
          {saving ? 'Saving...' : 'Save'}
        </Button>
        {msg && <Typography color="primary" mt={2}>{msg}</Typography>}
      </Paper>
    </Box>
  );
}
